import React from 'react';
import Layout from '../components/Layout';
import DocumentsMenu from '../components/DocumentsMenu';
import SecondPageLayout from '../components/Layout/SecondPageLayout';

const DocumentsMenuPage = () => {
    return (
        <SecondPageLayout withFooter={true}>
            <DocumentsMenu.Default/>
        </SecondPageLayout>
    );
};

export default DocumentsMenuPage;